class SwatchSelect extends HTMLElement {
    constructor() {
        super();

        this.swatches = this.querySelectorAll('.swatch');
        this.onSwatchClick = this.onSwatchClick.bind(this);
        
        this.cardWrapper = this.closest('.card-wrapper');
        this.cardImages = this.cardWrapper.querySelectorAll('.card__media');

        this.cardInfo = this.parentElement.parentElement;
        this.colorInfo = this.cardInfo.querySelector('.card__information__color');
    }

    onSwatchClick(e) {
        this.swatches.forEach(swatch => {
            swatch.classList.remove('active-swatch');
        });

        e.target.classList.add('active-swatch');

        const color = e.target.dataset.color.toLowerCase();
        const cardCollectionImage = this.cardWrapper.querySelector(`.card__media[data-color="${color}"]`);
        this.colorInfo.innerText = color;

        if (cardCollectionImage) {
            this.cardImages.forEach(image => {
                image.classList.add('hidden');
            });

            cardCollectionImage.classList.remove('hidden');
        }
    }

    connectedCallback() {
        this.swatches.forEach(swatch => {
            swatch.addEventListener('click', this.onSwatchClick);
        });
    }

    disconnectedCallback() {
        this.swatches.forEach(swatch => {
            swatch.removeEventListener('click', this.onSwatchClick);
        });
    }
}

if (!customElements.get('swatch-select')) {
    customElements.define('swatch-select', SwatchSelect);
}